function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "profile_avatar_2-a",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("mask", {
  id: "profile_avatar_2-b",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#profile_avatar_2-a"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  stroke: "#000",
  strokeDasharray: "1 4",
  strokeWidth: 2,
  mask: "url(#profile_avatar_2-b)",
  xlinkHref: "#profile_avatar_2-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464B5E",
  d: "M20,19 C17.794,19 16,17.206 16,15 C16,12.794 17.794,11 20,11 C22.206,11 24,12.794 24,15 C24,17.206 22.206,19 20,19 Z M20,21 C24.71,21 30.1114562,25.4164079 28,27 C25.8885438,28.5835921 13.8885438,28.4164079 12,27 C10.1114562,25.5835921 15.289,21 20,21 Z"
}));

var SvgProfileAvatar = function SvgProfileAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ProfileAvatar.76000fdb.svg";
export { ForwardRef as ReactComponent };